import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField, TextareaField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";

function Form({ data, mode, ...rest }) {
    const validationSchema = Yup.object({
        id: Yup.string().required("Required field").max(20, "Max length is 20 characters"),
        type: Yup.string().required("Required field").max(50, "Max length is 50 characters"),
        description: Yup.string().notRequired().max(2000, "Max length is 2000 characters"),
    });

    return (
        <FormikForm initialValues={data} validationSchema={validationSchema} {...rest}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControl component="fieldset">
                        <FormGroup row>
                            <InputField
                                disabled={mode === "update"}
                                fieldName="id"
                                label="Identifier *"
                                uppercase
                                fullWidth={false}
                                maxLength={20}
                            />
                            <InputField fieldName="type" label="Type *" maxLength={50} />
                            <TextareaField fieldName="description" label="Description" maxLength={2000} />
                        </FormGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string,
        description: PropTypes.string,
    }),
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
};

Form.defaultProps = {
    data: {
        id: "",
        type: "",
        description: "",
    },
};

export default Form;
